import { useQuery } from '@tanstack/react-query'
import type { SellerPortalCategoriesResponse } from 'typings'
import { useFetch } from './useFetch'

export function useSellerPortalCategories() {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/catalog-seller-portal/category-tree`,
    window.location.origin
  )

  async function fetcher() {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((r: SellerPortalCategoriesResponse) => r.roots)
  }

  return useQuery({ queryKey: ['seller-portal-categories'], queryFn: fetcher })
}
